import { Roles } from '@/utils/roles';
import { useRole } from '@/hooks/useRole';
import { UserStore } from '@/store/user';
import Loader from '@/commons/loader';
import AtmPage from '../pages/atm-page';
import WaitressPage from '../pages/waitress';
import NotLicensePage from '../pages/not-license-page';

const HomePage = () => {
  const { subscriptions } = UserStore.getState();
  const { authorized } = useRole([Roles.SUPER_ADMIN, Roles.ADMIN, Roles.ATM]);
  
  if (subscriptions?.loading) {
    return <Loader fullScreen />;
  }

  if (subscriptions.data && !subscriptions?.data?.isActive) {
    return <NotLicensePage />;
  }

  if (authorized) {
    return <AtmPage />;
  }

  return <WaitressPage />;
};

export default HomePage;
